import '../../../../../components/map/map'
import DrawControl from '../../../../../components/map/draw_control/draw_control';
import '../../../../../components/map/layer_control/layer_control';
import LocationBox from '../../../../../components/map/location_box/location_box';
import('../../../../../../styles/components/map/location_box.css')

//map layer provider icons
import openStreetImage from '../../../../../../images/map-icons/open-osmde.png'
import mapBoxStreetImage from '../../../../../../images/map-icons/mapbox-street.png'
import mapBoxWhiteBlackImage from '../../../../../../images/map-icons/mapbox-whiteblack.png'
import googleTerrainImage from '../../../../../../images/map-icons/google-terrain.png'
import ProgressBar from '../../../../../components/map/progress_bar/progress_bar';

export default function Map(opts = {}){
    let GENERAL_OPTIONS = opts.GENERAL_OPTIONS
    let mapComponent, layerControl, progressBar;
    let component_options = {
        zoom: false,
        animated_zoom: false,
        distance_line: {
            show:false,
            point: undefined,
            distante_marker: L.marker([0,0], {icon: L.divIcon({className: 'distance-line-label-marker', html: ''})}),
            line: L.polyline([], {color: '#f74f78'})
        }
    }
    //lista de basemaps para o mapa
    let basemaps={
        layers:[
            {title: 'default'}, {title: 'dark'}, {title:'satellite'}, {title:'navigation'}
        ]
    }

    //options para inicialização do componente mapa
    let options = {
        container: "#map_container",
        map_id: "map",
        zoom: 12,
        basemap: basemaps,
        temp_marker:{
            show_tooltip: true,
            tooltip_content:{
                latLng:true,
                closest_stations: true,
                distance:true,
                copy_button: true
            }
        }
        // loading: {show:true, position: 'full'}
    }
    this._station;
    this.getLayer = (layer) =>{
        return mapComponent.getLayer(layer)
    }

    this.getMap = _ =>{
        return mapComponent.getMap()
    }

    this.generate = () =>{
        mapComponent = new MapComponent(options)
        //gerando mapa
        mapComponent.generate()

        //adicionando camadas necessárias
        mapComponent.addLayerToMap(new L.markerClusterGroup(), 'markers')
        mapComponent.addLayerToMap(new L.featureGroup(), 'draw_group')

        mapComponent.addCustomPositionToMap('top', 'center')

        //gerando controle de criação de formas
        this.generateDrawControl()

        //gerando controle de camadas
        this.generateLayerControl()
        
        //gerando botao para abrir offcanvvas filter
        this.generateFilterButton()
        
        //gerando botão para abrir offcanvas de controle de camadas
        this.generateLayerButton()

        //gerando botão + componente para localização de coordenadas no mapa
        this.generateFindLocationBox()

        //gerando botões no canto inferior direito
        this.generateChartButtons()

        eventsHandler()

    }

    this.generateMarkers = () =>{
        let context = this
        mapComponent.clearLayer('markers')
        this._station.list.forEach(station=>{
            
            //criando marker
            let marker = L.marker([station.latitude, station.longitude],{
                icon: createDivIcon(undefined, ''), 
                station_id: parseInt(station.station_id),
                ugrhi: station.ugrhi_name,
                ugrhi_id: station.ugrhi_id,
                city: station.city_name,
                city_id: station.city_id,
                station_owner: station.station_owner,
                station_owner_id: station.station_owner_id,
                transmission_status: station.transmission_status,
                transmission_status_id: station.transmission_status
            })
            
            //criando tooltip
            let tooltip = L.tooltip({permanent:true, offset: new L.Point(3,-3), interactive:true, type:'tooltip'}).setContent(station.prefix)
            //adicionando markers na layer de markers que já está adicionada no mapa
            mapComponent.addLayerToFeature(
                'markers', marker
                
            )
            //adicionando tooltip ao marcador, sempre amostra por conta da option 'permanent'
            marker.bindTooltip(tooltip);

            //função custom. Usada para ativar/desativar ESTILO do marcador quando 'selecionado/sem seleção'
            marker._active = function(boolean){
                $(this._icon).toggleClass("selected", boolean)
                $(this._tooltip._container).toggleClass("selected", boolean)
            }

            //adicionando evento de click ao marker (tooltip acaba pegando de revesgueio)
            marker.on('click', function(e){
                $(document).trigger('tooltip:clicked', {station_id:station.id})
            })
            
            //adicionando instancia do marker no objeto do posto
            station.marker = marker
        })
        
        mapComponent.getMap().on('zoomend', function() {
            context._station.list.forEach(station=>{
                if(station.marker._icon!=undefined){
                    station.marker._active(station.selected || false)
                }
            })
        });
    }

    this.reloadMarkers = (markers) =>{
        //transformando lista de markers em clusterGroup
        let marker_cluster = mapComponent.markersToCluster(markers, {
            disableClusteringAtZoom: 12,
            removeOutsideVisibleBounds:true,
            spiderfyOnMaxZoom:false
        })
            
        //removendo a camada de cluster atualmente no mapa
        mapComponent.removeLayer('markers')
        
        //adicionando a nova camada cluster no mapa
        mapComponent.addLayerToMap(marker_cluster, 'markers')
        
        
        this.zoomToMarkers()
    }

    this.zoomToMarkers = () =>{
        //tentando dar zoom nos markers do mapa (caso a camada esteja sem markers, vai dar erro)
        if(!mapComponent.zoomToLayer('markers')){
            
            //dando zoom no limite estadual caso não tenha nenhum marker, caso a camada não esteja carregada por qualquer motivo, vai dar erro
            if(!mapComponent.zoomToLayer('state_limit')){
                
                //retornando para um zoom default caso não encontre as camadas anteriores. Impossivel dar erro :)
                mapComponent._map.setView([-22.37, -48.55], 7)
            }
        }
    }

    this.invalidateSize = () =>{
        if(mapComponent){
            mapComponent.getMap().invalidateSize();
        }
        
    }

    this.zoomToMarker = (station_id) =>{
        let marker = Object.values(mapComponent.getLayer('markers').pm._layers).filter(x=>x.options.station_id == station_id)[0]
        if(marker != undefined){
            mapComponent.zoomToCoord(marker._latlng, component_options.animated_zoom, 15)
        }
    }

    this.zoomToLocation = (latLng)=>{
        mapComponent.zoomToCoord(latLng, false, 15)
    }

    this.zoomToLayer = layer_id =>{
        mapComponent.zoomToLayer(layer_id)
    }

    function createDivIcon(class_name, html){
        return L.divIcon({className: "station-icon", html:html})
    }

    this.getMaker = (station_id) => {
        return Object.values(mapComponent.getLayer('markers')._layers).filter(x=>x.options.station_id == station_id)[0]
    }

    this.showMarker = (station, boolean)=>{
        if(boolean){
            mapComponent.getLayer('markers').addLayer(station.marker)
        } else {
            try{
                mapComponent.getLayer('markers').removeLayer(station.marker)
            } catch(e){
                
            }
            
        }
    }

    this.showOverlay = boolean =>{
        if(boolean){
            mapComponent.showOverlay()
        } else {
            mapComponent.hideOverlay()
        }
    }

    this.generateProgressBar = _ =>{
        progressBar = new ProgressBar({mapComponent:mapComponent, overlay:true,showCount:true,  title: "Carregando lista de postos"})
        progressBar.show(true)
    }

    this.updateProgressBar = (current, total) =>{
        progressBar.updateTotal(current,total)
    }

    this.hideProgressBar = _ =>{
        progressBar.show(false)
    }

    this.markersToCluster = (markers) =>{
        return mapComponent.markersToCluster(markers)
    }
    // Inicializando/configurando LeafletPM (criação das formas geométricas)
    this.generateDrawControl = () =>{

        //criando Dom element que receberá o DrawControl (pode ficar fora do mapa, eu quem escolhi colocar dentro do mapa em uma posição personalizada)
        mapComponent.createDomElement("draw_control", 'topcenter', 'html', undefined, 'dom-element-default dom-draw-control')

        //gerando DrawControl
        let drawControl = new DrawControl(
            mapComponent.getMap(), //map
            {container:'.dom-draw-control', feature_group: mapComponent.getLayer('draw_group')} //options
        )
        drawControl.generate()

        //evento disparado quando o desenho é finalizado. ANTES do pm:create
        mapComponent.getMap().on('draw:drawstop', function(e){
            mapComponent.clearLayer('draw_group')
        })

        //evento disparado quando a forma é criada. APÓS o pm:drawend
        mapComponent.getMap().on('draw:created', function(e){
            
            //layer desenhada
            let layer = e.layer
            
            //adicionando referência da layer na camada 'draw_group'
            mapComponent.addLayerToFeature('draw_group', layer)

            //caso a layer desenhada seja 'circle'
            if(e.layerType == 'circle'){
                //markers dentro do circle
                let markers = mapComponent.getNearbyMarkers(layer.getLatLng(), layer.getRadius())
                
                //evento para selecionar os postos
                $(document).trigger('stations:select_multiple', {station_ids: markers.map(x=>x.options.station_id), select:true, show_toast:true})

            } else { //caso seja um polygon

                //markers dentro da layer
                let markers = mapComponent.getWithinMarkers(layer)
                
                //evento para selecionar os postos
                $(document).trigger('stations:select_multiple', {station_ids: markers.map(x=>x.options.station_id), select:true, show_toast:true})
            }
        })
    }

    this.getNearbyMarkers = (latLng, radius) =>{
        return mapComponent.getNearbyMarkers(latLng, radius)
    }

    this.generateLayerControl = () =>{
        let layers_opts = [
            ["Limite Municipal", "Limites municipais do estado de São Paulo","city_limit", 'city', true, 'name', 'cod_ibge'],
            ["Limite Ugrhi", "Limites das ugrhis de São Paulo","ugrhi_limit", 'ugrhi', true, 'nome', 'codigo'],
            ["Limite SubUgrhi", "Limites das subugrhis de São Paulo","subugrhi_limit", 'subugrhi', true, 'nome', 'codigo'],
            ["Limite Estadual", "Limites do estado de São Paulo","state_limit", 'state', false]
        ]

        layerControl = new LayerControl({
            map: mapComponent.getMap(),
            container: "#layer_control_container",
            layers: generateLayerObjs(layers_opts),
            filter_options: {clear:true}
        })

        layerControl.generate()
    }

    this.showLayersByFilter = filter_options =>{
        if(filter_options.ugrhi_id && filter_options.ugrhi_id.length > 0){
            let ugrhi_cods = filter_options.ugrhi_id.map(u=>UGRHI_ID_TO_COD[u])
            if(layerControl.filterFeaturesFromFeatureGroup(ugrhi_cods, 'ugrhi')){
                mapComponent.zoomToLayer('ugrhi_limit')
            }
        }
    }
    

    this.generateFilterButton = () =>{
        mapComponent.createDomElement("filter_button", 'topright', '<i class="fas fa-filter text-white"></i>', {"click": ()=> $(document).trigger("dom-element-filter:click") }, 'dom-element-default')
    }
    
    this.generateLayerButton = () =>{
        mapComponent.createDomElement("layer_button", 'topright', '<i class="fas fa-layer-group text-white"></i>', {"click": ()=> $(document).trigger("dom-element-layer:click") }, 'dom-element-default')
    }

    this.generateLocationButton = () =>{
        mapComponent.createDomElement("location_button", 'topright', '<i class="fas fa-crosshairs text-white"></i>', {"click": ()=> $(document).trigger("dom-element-location:click") }, 'dom-element-default')
    }

    this.generateChartButtons = () =>{
        mapComponent.createDomElement("chart_button", 'bottomright', '<i class="fas fa-chart-bar text-white"></i>', {"click": ()=> $(document).trigger("dom-element-chart:click") }, 'dom-element-default main-button button-chart')
        mapComponent.createDomElement("config_button", 'bottomright', '<i class="fas fa-cog text-white"></i>', {"click": ()=> $(document).trigger("dom-element-config:click") }, 'dom-element-default main-button main-button-small button-config')
        mapComponent.createDomElement("stations_button", 'bottomright', '<i class="fas fa-list text-white"></i>', {"click": ()=> $(document).trigger("dom-element-stations:click") }, 'dom-element-default main-button main-button-small button-station')
        mapComponent.createDomElement("help_button", 'bottomright', '<i class="fas fa-question text-white"></i>', {"click": ()=> $(document).trigger("dom-element-help:click") }, 'dom-element-default main-button main-button-small button-help')
        if(GENERAL_OPTIONS.station_type == 'flu' && cookies.user_token){
            mapComponent.createDomElement("views_button", 'bottomright', '<i class="fas fas fa-tools"></i>', {"click": ()=> $(document).trigger("dom-element-views:click") }, 'dom-element-default main-button main-button-small button-view')
        }
    }

    this.generateFindLocationBox = () =>{
        let locationBox = new LocationBox(mapComponent, {position: "topright", title: "Localizar coordenada", nearby_options:[1,5,10]})
        locationBox.generate()
    }

    function generateLayerObjs(layers_opts){
        let layers = []
        layers_opts.forEach(opts=>{
            layers.push({
                title: opts[0],
                limit_type: opts[3],
                description: opts[1],
                feature_filter:{
                    filterable: opts[4],
                    field: opts[5],
                    id: opts[6]
                },
                controls:{
                    stroke: {title: 'Traçado',color: true,opacity: true, width:5,dcolor: '#545454', dopacity:0.8},
                    fill: {title: 'Prenchimento',color:true, opacity: true, dcolor: '#545454', dopacity:0.1},
                },
                id: opts[2],
                url: layers_url[opts[2]],
                options:{
                    show:((opts[2] == 'state_limit') ? true : false)
                },
                style:{
                    fill:{
                        color:'#545454',
                        opacity:0.1,
                    },
                    stroke:{
                        color:'#545454',
                        opacity:0.8,
                    },
                }
            })
        })
        return layers
    }

    this.addLayerToFeature = (layer, layer_id) =>{
        mapComponent.clearLayer('draw_group')
        mapComponent.addLayerToFeature(layer_id, layer)
    }

    function eventsHandler(){
        mapComponent.getMap().on('mousemove', e=>{
            if(component_options.distance_line.show){
                component_options.distance_line.line.addTo(mapComponent.getMap())
                component_options.distance_line.distante_marker.addTo(mapComponent.getMap())
                if(component_options.distance_line.point){
                    component_options.distance_line.line.setLatLngs([component_options.distance_line.point,[e.latlng.lat,e.latlng.lng]])
                    let center = component_options.distance_line.line.getCenter()
                    component_options.distance_line.distante_marker.setLatLng(center)
                    let distance = mapComponent.getMap().distance(component_options.distance_line.line.getLatLngs()[0],component_options.distance_line.line.getLatLngs()[1])
                    $('.distance-line-label-marker').html((distance/1000).toFixed(3)+" km")
                }
            } else {
                //not working  :(
                component_options.distance_line.line.remove()    
                component_options.distance_line.distante_marker.remove()
            }
        })

        mapComponent.getMap().on('click', e=>{
            component_options.distance_line.show = false
            component_options.distance_line.line.remove()
            component_options.distance_line.distante_marker.remove()
        })

        $(document).on('click', '.location-marker-tooltip-button-distance', e=>{
            $(e.target).toggleClass('active')
            component_options.distance_line.show = (component_options.distance_line.show) ? false : true
            component_options.distance_line.point = [e.target.dataset.lat,e.target.dataset.lng]
        })
    }
    let UGRHI_ID_TO_COD = {
        4: 2,
        5:3,
        21:4,
        6:5,
        7:6,
        2:7,
        8:8,
        9:9,
        10:10,
        11:11,
        12:12,
        13:13,
        14:14,
        22:15,
        15:16,
        16:17,
        17:18,
        18:19,
        24:20,
        19:21,
        20:22,
        3:1
    }
}